import QuestionExtraText from "./QuestionExtraText";

export default QuestionExtraText;
